import React from "react";
import Footer from "../../common/Footer/Footer";
import UserPage from "../../common/UserPage/UserPage";
import AdminTestsPage from "../../components/AdminTests/AdminTestsPage"


const AdminTestsHome = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <UserPage />
      <div className="flex-1 flex flex-col">
        <AdminTestsPage />
      </div>
      <Footer />
    </div>
  );
};

export default AdminTestsHome;
